import { Card, Text, Title } from "../../../UI";
import style from './FamilyGroupBenefits.module.css';

import iconReservaHora from '../../../../assets/img/icons/icon-reserva-hora.png';
import iconMedicalHistory from '../../../../assets/img/icons/icon-historial-medico.png';
import iconExams from '../../../../assets/img/icons/icon-examenes.png';
import iconBudget from '../../../../assets/img/icons/icon-solicitar-presupuesto.png';

export const FamilyGroupBenefits = () => {
    return (
        <div className={style.benefits__container}>
            <Title component="h2" size="20" weight='600'>Aún no tienes integrantes en tu Grupo familiar</Title>
            <Text size="13" className="mt-10">Crea tu Grupo Familiar y gestiona la información médica de tus seres queridos. A continuación, te mostramos las acciones disponibles una vez añadidos.</Text>
            
            <div className={style.benefits}>
                <div className={style.benefit}>
                    <img src={iconReservaHora} alt="Reserva" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Reservar horas</h3>
                    <p className={style.benefit__description}>Para menores de edad y mayores de 18 años</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconMedicalHistory} alt="Historial médico" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Ver historial médico</h3>
                    <p className={style.benefit__description}>Para menores de edad</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconExams} alt="Exámenes" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Consultar exámenes</h3>
                    <p className={style.benefit__description}>Para menores de edad</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconBudget} alt="Solicitar presupuestos" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Solicitud de presupuestos</h3>
                    <p className={style.benefit__description}>Para menores de edad</p>
                </div>

            </div>
        </div>
    )
}
